import { getAddOnRates, hasAddOnRates, Locales, PrimaryMainColor } from "@simplyk/common";

import { useCurrentUserContext } from "../../../../../common/contexts/CurrentUserContext";
import { mapDataToProvideRates } from "../../../../../common/helpers/form-edition";
import { useLiveFormEditorContext } from "../../common/LiveFormEditorContext";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useLocaleField } from "@/canvas/features/FormV2/helpers/useLocaleField";
import { CouponPDFPreview } from "@/components/PDFPreview/CouponPDFPreview";
import { getPreviewEventDates } from "@/features/LiveFormEditor/LivePreview/ETicketLivePreview/helpers/getPreviewEventDates";

export const CouponLivePreview = () => {
  const { liveFormData, apiFormObject: apiTicketing } = useLiveFormEditorContext<"ticketing">();
  const { organization } = useCurrentUserContext();
  const getField = useLocaleField();

  const addOnRates = getAddOnRates(apiTicketing.rates);
  const mappedAddOnRates = mapDataToProvideRates(addOnRates, liveFormData?.ticketing.locale || Locales.EN);
  const ticketingField = getField(liveFormData?.ticketing.ticketingFields);

  const eventDates = getPreviewEventDates({
    occurrences: apiTicketing.occurrences,
    recurrences: apiTicketing.recurrences,
  });

  const getPreviewCouponInHtmlInput = {
    address: apiTicketing.address || null,
    eventTimezone: apiTicketing.eventTimezone || null,
    rateTitle: mappedAddOnRates?.[0]?.name || null,
    photoUrl: addOnRates?.[0]?.photoUrls?.[0] || null,
    formTitle: ticketingField?.title || null,
    organizationName: organization?.name || null,
    startUtc: eventDates?.startUtc || null,
    endUtc: eventDates?.endUtc || null,
    ticketingColor: liveFormData?.ticketing.color || PrimaryMainColor,
    formLocale: liveFormData?.ticketing.locale || Locales.EN,
    organizationCountry: organization?.country ?? null,
  };

  const ticketing = liveFormData?.ticketing;
  if (!ticketing?.generateQrCode || !ticketing.generateAddOnQrCode || !hasAddOnRates(apiTicketing.rates)) {
    return null;
  }

  return <CouponPDFPreview getPreviewCouponInHtmlInput={getPreviewCouponInHtmlInput} />;
};
